/* Component  */
import { decryptionAPI } from './Encryption';

/* Services  */
import { SSOAPIURL } from '../services/axiosServices/ApiEndPoints';

const axios = require('axios');

export const ssoAxiosInstance = axios.create({
    baseURL: SSOAPIURL
})

ssoAxiosInstance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
)

const isHandlerEnabled = (config = {}) => {
    return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ?
        false : true
}

const requestHandler = (request) => {
    if (isHandlerEnabled(request)) {
    }
    return request
}

ssoAxiosInstance.interceptors.request.use(
    request => requestHandler(request)
)

const errorHandler = (error) => {
    if (isHandlerEnabled(error.config)) {
        if (error.response && error.response.status === 403) {
            window.location.href = "/UnAuthorized";
        }
    }
    return Promise.reject({ ...error })
}

const successHandler = (response) => {
    if (isHandlerEnabled(response.config)) {
        response = decryptionAPI(response.data);
    }
    return response
}

export const axiosInstanceWithoutEnrypt = axios.create({
    baseURL: SSOAPIURL
})
